var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSendPrimaryz(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.40213 2.30828C1.11808 1.46086 2.00358 0.694865 2.80127 1.09794L27.8411 13.7505C28.577 14.1224 28.572 15.175 27.8326 15.5398L2.80212 27.8915C2.00197 28.2863 1.12451 27.515 1.41351 26.6708L4.61906 17.3073C4.67831 17.1342 4.82733 17.0073 5.00763 16.9764L19.5587 14.4821L5.01621 12.2388C4.83132 12.2103 4.67781 12.0809 4.61836 11.9036L1.40213 2.30828Z",
    fill: "#97144D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSendPrimaryz);
export default __webpack_public_path__ + "static/media/ic_send_primaryz.d6b02a0717b40f59aed3cf19475b6c5d.svg";
export { ForwardRef as ReactComponent };